"use client";
import { ActiveTab, QueueType, useGenerator } from "@/app/context/GeneratorContext";
import { useMemo, useState, useEffect } from "react";

export default function GenerationTabs({ translations }: { translations: any }) {
  const { activeTab, setActiveTab, jobHistory } = useGenerator();

  const pendingJobCount = useMemo(
    () =>
      jobHistory?.filter(
        (job) => job.status === "pending" || job.status === "delayed" || job.status === "active",
      )?.length ?? 0,
    [jobHistory],
  );

  return (
    <div className="mx-auto w-full xl:w-8/12">
      <div className="flex flex-row items-center justify-center border-l-[0.5px] border-r-[0.5px] border-t-[0.5px] border-grey-outline bg-[#2B2D31] px-4 py-2 sm:rounded-tl-xl sm:rounded-tr-xl">
        <button
          onClick={() => setActiveTab(ActiveTab.Generation)}
          className={`flex items-center px-4 py-2 text-sm font-bold ${
            activeTab === ActiveTab.Generation ? "text-white" : "text-gray-400 hover:text-white"
          }`}
        >
          {translations.generation}
        </button>
        {jobHistory?.length > 0 && (
          <>
            <div className="h-5 w-[1px] bg-grey-outline" />
            <div className="relative">
              <button
                onClick={() => setActiveTab(ActiveTab.History)}
                className={`flex items-center px-4 py-2 text-sm font-bold ${
                  activeTab === ActiveTab.History ? "text-white" : "text-gray-400 hover:text-white"
                }`}
              >
                {translations.history}
                <span
                  className={`ml-2 flex h-5 w-5 items-center justify-center rounded-full bg-crp-red text-xs text-white ${
                    pendingJobCount > 0 ? "animate-bounce-once" : ""
                  }`}
                  style={{ opacity: pendingJobCount > 0 ? 1 : 0 }}
                >
                  {pendingJobCount}
                </span>
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
